import * as yup from "yup";

import { messagesConstants } from "@/constants";

export const createEventFormsSchema = {
    copyEvent: yup.object({
        event: yup.object().test(
            "is-not-empty",
            messagesConstants.inputsMsgs.event,
            (value) => Object.keys(value).length > 0,
        ).required(messagesConstants.inputsMsgs.event),
        title: yup.string().required(messagesConstants.inputsMsgs.title),
    }),
    titleOnly: yup.object({ title: yup.string().required(messagesConstants.inputsMsgs.title) }),
    useTemplate: yup.object({
        template: yup.object().test(
            "is-not-empty",
            messagesConstants.inputsMsgs.template,
            (value) => Object.keys(value).length > 0,
        ).required(messagesConstants.inputsMsgs.template),
        title: yup.string().required(messagesConstants.inputsMsgs.title),
    }),
};
